import { render, staticRenderFns } from "./ObjectInfo.vue?vue&type=template&id=7abd8da0&"
import script from "./ObjectInfo.vue?vue&type=script&lang=js&"
export * from "./ObjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports